import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'v3/components/Button';
import Modal from 'v3/components/Modal';
import Select from 'v3/components/Select';
import Text from 'v3/components/Text';

const ACTION_OPTIONS = [
  { value: 'allow', label: 'Permitir' },
  { value: 'deny', label: 'Negar' },
];

export default function PermissionsModalAdd({
  isOpen,
  onClose,
  permissionOptions,
  onAdd,
}) {
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [selectedAction, setSelectedAction] = useState(ACTION_OPTIONS[0]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  function handleClose() {
    setSelectedPermission(null);
    setSelectedAction(ACTION_OPTIONS[0]);
    setError('');
    onClose();
  }

  async function handleAddPermission() {
    if (loading) return;
    
    if (!selectedAction) {
      setError('Selecione uma ação');
      return;
    }

    if (!selectedPermission) {
      setError('Selecione uma permissão');
      return;
    }

    setLoading(true);
    const added = await onAdd(selectedPermission, selectedAction.value);
    if (added) {
      handleClose();
    }
    setLoading(false);
  }

  function onSearchPermission(value) {
    if (!value) {
      return permissionOptions
    }

    function hasWord(text, word) {
      if (!text) return
      return text.toLowerCase().includes(word)
    }

    return permissionOptions.filter(permission => {
        const nameWithGroup = `${permission.name} ${permission.group}`.toLowerCase()

        if (nameWithGroup.includes(value.toLowerCase())) {
          return true
        }

        if (hasWord(permission.name, value.toLowerCase())) {
          return true
        }

        if (hasWord(permission.group, value.toLowerCase())) {
          return true
        }

        return false
    })
  }

  return (
    <Modal
      show={isOpen}
      onHide={handleClose}
      size="lg"
      heading={
        <Text color="dark" type="header">
          Incluir permissão adicional
        </Text>
      }
      body={
        <Row>
          <Col xs={12} md={5} className="mb-3">
            <Select
              label="Ação"
              options={ACTION_OPTIONS}
              value={selectedAction}
              getOptionLabel={option => option.label}
              getOptionValue={option => option.value}
              onChange={value => setSelectedAction(value)}
              disableClear
            />
          </Col>
          <Col xs={12} md={7} className="mb-3">
            <Select.Async
              label="Permissão"
              onSearch={onSearchPermission}
              options={permissionOptions}
              value={selectedPermission}
              getOptionLabel={option => `${option.name} - ${option.group}`}
              getOptionValue={option => option.id}
              onChange={value => {
                setSelectedPermission(value);
                setError('');
              }}
              error={error}
            />
          </Col>
          <Col xs={12} className="d-flex justify-content-end">
            <Button
              variant="primary"
              loading={loading}
              onClick={handleAddPermission}
              disabled={!selectedPermission || loading}
            >
              <Text weight="500" color="white" type="regular">
                Adicionar
              </Text>
            </Button>
          </Col>
        </Row>
      }
    />
  );
}
